export default __webpack_public_path__ + "static/media/FECHAS_16.08ae9a60.png";